import { Injectable } from '@angular/core';

interface EventPayload {
  eventName: string;
  data: any;
}

@Injectable({
  providedIn: 'root'
})
export class AppEventService {
  dispatchEvent(eventName: string, data: any): void {
    let tensorLinks = (window as any).TensorLinks || {};
    if (tensorLinks && tensorLinks.globalEventBus) {
      let eventBus = (window as any).TensorLinks.globalEventBus;
      eventBus.next({ eventName, data });
    } else {
    }

  }
}
